import type { FC } from "react"
import { MetadataRow } from "../../molecules"
import MetadataTag from "~/components/design-system/atoms/Tag/MetadataTag"
import ClockIcon from "~/icons/Clock"

type ProductMetadataRowProps = {
  tags: string[]
}

export const ProductMetadataRow: FC<ProductMetadataRowProps> = ({ tags }) => {
  return (
    <MetadataRow>
      {tags.map((tag, index) => (
        <MetadataTag
          key={`${tag}-${index}`}
          icon={
            tag.toUpperCase().includes("MINS") ? (
              <ClockIcon className="w-3 h-3" />
            ) : undefined
          }
        >
          {tag}
        </MetadataTag>
      ))}
    </MetadataRow>
  )
}
